import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { getLocalJitsiVideoTrack } from '../../../base/tracks/functions.web';
import { getVideoSettingsVisibility } from '../../../settings/functions.web';
import { isVideoSettingsButtonDisabled } from '../../functions.web';
import VideoMuteButtonMobile from "./VideoMuteButtonMobile";
/**
 * Button used for video & video settings.
 *
 * @returns {ReactElement}
 */
class VisitorVideoSettingsButtonMobile extends Component {
    /**
     * Initializes a new {@code VisitorVideoSettingsButtonMobile} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
    }
    /**
     * Implements React's {@link Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { buttonKey, notifyMode } = this.props;
        return React.createElement(VideoMuteButtonMobile, { buttonKey: buttonKey, notifyMode: notifyMode });
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { permissions = { video: false } } = state['features/base/devices'];
    const { isNarrowLayout } = state['features/base/responsive-ui'];
    const { gumPending } = state['features/base/media'].video;
    return {
        gumPending,
        hasPermissions: permissions.video,
        hasVideoTrack: Boolean(getLocalJitsiVideoTrack(state)),
        isDisabled: isVideoSettingsButtonDisabled(state),
        isOpen: Boolean(getVideoSettingsVisibility(state)),
        visible: !isMobileBrowser() && !isNarrowLayout
    };
}
const mapDispatchToProps = {};
export default translate(connect(mapStateToProps, mapDispatchToProps)(VisitorVideoSettingsButtonMobile));
